import React from 'react'

export default function(props) {
	const { result } = props
	const textClass = result.image ? 'text' : 'text-only'
  const titleClass = result.jobTitle ? ' has-job-title': ''

  return (
  	<>
  	{result.image && (
  	  <div className="image">
  	    <img src={result.image}/>
  	  </div>
  	)}
  	<div className={textClass}>
  	  <h3 className={`result-title`+titleClass}>{result.title}</h3>
  	  <p className="result-job-title">{result.jobTitle}</p>
  	  <div dangerouslySetInnerHTML={{__html: result.text}} />
  	  <div className="people-contact">
  	    <p className="people-contact-email" onClick={(e) => { handleClick(e, `mailto:${result.emailAddress}`) }}>
          Email: <span className="rich-link">{result.emailAddress}</span>
        </p>
  	    <p className="people-contact-phone" onClick={(e) => { handleClick(e, `tel:${result.emailAddress}`) }}>
          Phone: <span className="rich-link">{result.phoneNumber}</span>
        </p>
  	  </div>
  	  {result.keyLinks.length > 0 && (
  	    <>
  	    <p className="keylinks-title">KEY LINKS</p>
  	    <div className="result-keylinks">
  	      {result.keyLinks.map((keyLink, index) => {
  	        return (<span key={index} className="keylink" onClick={(e) => { handleClick(e, keyLink.url) }}>{keyLink.text}</span>)
  	      })}
  	    </div>
  	    </>
  	  )}
  	</div>
  	</>
  )

}

function handleClick(event, target) {
  event.preventDefault()
  event.nativeEvent.stopImmediatePropagation()
  window.location.href = target
}